import React from 'react'
import Section from '../Section'
import { Row, Col } from 'components/Layout'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import s from './PickANumber.scss'
import sText from 'components/Text/Text.scss'

export default props => {
  const numberType = props.numberType.replace(' ', '-')
  const items = [
    {
      title: 'Pick a Number',
      description: `Search for an available ${props.numberType} number on the number lookup tool or obtain a phone word quote.`,
      img: `/static/images/large-icons/${numberType}-phone-numbers.png`,
    },
    {
      title: 'Pick a Plan',
      description:
        'Pick a MyPickle plan that works for you from the range of plans we have available.',
      img: `/static/images/large-icons/${numberType}-number-cost.png`,
    },
    {
      title: 'Sign up',
      description: `Sign up today and start using your new ${props.numberType} number instantly. That's it, easy as 1..2..3!`,
      img: `/static/images/large-icons/buy-${numberType}-number.png`,
    },
  ]

  return (
    <Section
      color={props.color}
      paddingTop={props.paddingTop}
      paddingBottom={props.paddingBottom}
      style={{ textAlign: 'center' }}
    >
      <h2 className={cn(sText.heading3, sText.primary)}>How to get a {props.numberType} number:</h2>
      <div className={cn(sText.descrip1, sText.accent)} style={{ marginTop: '10px' }}>
        Pickle makes it easy to start using your {props.numberType} number right away.
      </div>
      <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-col'])}>
        {items.map((item, idx) => (
          <Col
            key={idx}
            className={cn(s.item, sLay['flex-gt-xs-33'])}
            style={{ marginTop: '50px', marginBottom: '50px' }}
          >
            <img src={item.img} />
            <h3 className={sText.heading4}>{item.title}</h3>
            <div className={sText.descrip2}>{item.description}</div>
          </Col>
        ))}
      </Row>

      <Button
        onClick={() =>
          props.showNumbersFormModal({
            numberType: props.numberType === 'phone word' ? '1300' : props.numberType,
          })
        }
        size="lg"
        color="primary"
      >
        Pick a {props.numberType} number
      </Button>
    </Section>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PickANumber/PickANumber.jsx